import { Button, Loader } from '@120wateraudit/envirio-components'
import {
  Device,
  mediaScreen
} from '@120wateraudit/envirio-components/dist/utils/mediaScreen'
import React, { useCallback, useContext } from 'react'
import { Container as BaseContainer } from 'semantic-ui-react'

import AuditLogGrid from 'src/components/Communications/AuditLogGrid'
import { ModalContext } from 'src/modules/Modal'
import ProgramsAndSamplingEventsRPC from 'src/rpcs/ProgramsAndSamplingEvents'
import { Location } from 'src/types/Location'
import styled from 'styled-components'

interface Props {
  accountId: number
  location: Location
}

const LocationCommunicationsContainer: React.FC<Props> = ({
  accountId,
  location
}) => {
  const { openModal } = useContext(ModalContext)
  const openSendCommunicationModal = useCallback(() => {
    openModal('sendCommunication', {
      accountId,
      locationIds: [location.id]
    })
  }, [openModal, accountId, location.id])

  return (
    <ProgramsAndSamplingEventsRPC accountId={accountId}>
      {({ programs, samplingEvents }) => {
        if (!programs || !samplingEvents) {
          return <Loader />
        }

        return (
          <Container>
            <ButtonWrapper>
              <SendCommunicationButton
                onClick={openSendCommunicationModal}
                variant="primary">
                Send Communication
              </SendCommunicationButton>
            </ButtonWrapper>
            <AuditLogGrid
              accountId={accountId}
              columns={[
                {
                  name: 'Communication Name',
                  key: 'name',
                  sortable: false
                },
                {
                  name: 'Delivery Method',
                  key: 'communicationType',
                  sortable: false
                },
                {
                  name: 'Event',
                  key: 'eventName',
                  sortable: false
                },
                {
                  name: 'Date Sent',
                  key: 'createdOn',
                  sortable: true
                },
                {
                  name: 'Status',
                  key: 'status',
                  sortable: true
                },
                {
                  name: 'Tracking Link',
                  key: 'trackingId',
                  sortable: false
                },
                {
                  name: '',
                  key: 'actions',
                  sortable: false
                }
              ]}
              locationId={location.id}
              programs={programs}
              samplingEvents={samplingEvents}
            />
          </Container>
        )
      }}
    </ProgramsAndSamplingEventsRPC>
  )
}

const Container = styled(BaseContainer)`
  margin-top: 2rem;

  ${mediaScreen({
    device: Device.Tablet,
    style: {
      marginTop: '1rem'
    }
  })}
`

const SendCommunicationButton = styled(Button)`
  width: initial;
`
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`

export default LocationCommunicationsContainer
